import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import SignInPage from "@/pages/Auth/SignInPage.vue";
import SignUpPage from "@/pages/Auth/SignUpPage.vue";
import ForgotPasswordPage from "@/pages/Auth/ForgotPasswordPage.vue";
import ResetPasswordPage from "@/pages/Auth/ResetPasswordPage.vue";

import DashboardPage from "@/pages/Dashboard/DashboardPage.vue";

import ErrorPage from "@/pages/ErrorPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/autenticar/acessar",
    name: "SignInPage",
    component: SignInPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/autenticar/criar-conta",
    name: "SignUpPage",
    component: SignUpPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/autenticar/esqueci-minha-senha",
    name: "ForgotPasswordPage",
    component: ForgotPasswordPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/autenticar/resetar-senha/:token(.*)",
    name: "ResetPasswordPage",
    component: ResetPasswordPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "DashboardPage",
    component: DashboardPage,
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/execucoes",
    name: "ExecutionPage",
    component: () => import("@/pages/Execution/ExecutionPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/integracoes",
    name: "IntegrationsPage",
    component: () => import("@/pages/Integrations/IntegrationsPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
    {
    path: "/queries",
    name: "QueriesPage",
    component: () => import("@/pages/Queries/QueriesPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/conectores/entrada",
    name: "ConnectorsInPage",
    component: () => import("@/pages/Connectors/ConnectorsInPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/conectores/saida",
    name: "ConnectorsOutPage",
    component: () => import("@/pages/Connectors/ConnectorsOutPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/pagamentos/assinaturas",
    name: "SubscriptionsPage",
    component: () => import("@/pages/Payment/SubscriptionPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/pagamentos/historico",
    name: "PaymentHistoryPage",
    component: () => import("@/pages/Payment/PaymentHistoryPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/usuarios",
    name: "UsersPage",
    component: () => import("@/pages/Users/UsersPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/usuarios/novo-usuario",
    name: "NewUserPage",
    component: () => import("@/pages/Users/NewUserPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/usuarios/editar-usuario/:user_id",
    name: "EditUserPage",
    component: () => import("@/pages/Users/EditUserPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/configuracoes/notificacoes",
    name: "NotificationEmailsPage",
    component: () => import("@/pages/Settings/NotificationEmailsPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  {
    path: "/ticket",
    name: "TicketPage",
    component: () => import("@/pages/Support/TicketPage.vue"),
    meta: {
      requiresAuth: true,
      roles: ["admin"],
    },
  },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
  { path: "/conta-ativada", name: "EmailValidationPage", component: () => import("@/pages/EmailConfirmationPage.vue") },  
  { path: "/connector-auth", name: "ConnectorAuthenticationConfirmationPage", component: () => import("@/pages/ConnectorAuthenticationConfirmationPage.vue") },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem("token");
    // const user = localStorage.getItem("user");

    if (token /* && user */) {
      // const tokenDecoded = jwtDecode(token, {
      //   header: false,
      // });
      // const userDecoded = JSON.parse(user);
      // const isExpired =
      //   !!tokenDecoded.exp && Date.now() > tokenDecoded.exp * 1000;
      // if (isExpired) {
      //   useAuthStore().setLogout();
      //   router.push({ path: "/autenticar/acessar" }).then(() => {
      //     router.go(0);
      //   });
      // }
      // const userRole = userDecoded.type;
      // if (Array.isArray(to.meta.roles) && !to.meta.roles.includes(userRole)) {
      //   router.go(-1);
      // } else {
      //   next();
      // }

      next();
    } else {
      router.push({ path: "/autenticar/acessar" }).then(() => {
        router.go(0);
      });

      next();
    }
  } else {
    const token = localStorage.getItem("token");
    // const user = localStorage.getItem("user");

    if (to.name === "SignInPage" && token /* && user */)
      router.push({ path: "/" });

    // Non-protected route, allow access
    next();
  }
});

export default router;
